import React, {Component} from 'react'
import Header from './Header'
import MainMenu from './MainMenu'

class Column1 extends Component {

  render() {
    return (
      <div>
        <Header />
        <MainMenu />
      </div>
    )
  }
}

export default Column1


// WEBPACK FOOTER //
// ./src/Column1.js